// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-ancient-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12.0016 2C12.0016 4.66661 15.0559 7.05546 17 7.77773V8.0001H16.9996V12H20V21H4V12H7.00195V8H7.00234V7.77695C8.94726 7.05373 12.0016 4.66565 12.0016 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12.002 21L12.002 17","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4.00001 21H3M4.00001 21H20M4.00001 21L4 12M20 21H21M20 21L20 12M20 12L4 12M20 12H21M4 12H3M6 8C7.6 8 12.0016 5.2 12.0016 2C12.0016 5.2 16.4 8 18 8M7.00195 8L16.9996 8L17 12M7 8V12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-ancient-1')
export default class CityAncient1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-ancient-1',
    }
  }
}
